import { instance } from "./api";

export const stopListsApi = {
  getSections(restaurant_id: string) {
    // return instance.get(`/v3/restaurant/${restaurant_id}/sections`);
  },
  getProducts(
    rest_id: string,
    menu_id: string,
    per_page: number = 10,
    page: number = 1,
    available?: boolean
  ): Promise<any> {
    return instance.get(
      `/v3/restaurant/${rest_id}/products?page=${page}&per_page=${per_page}&field=price${
        available !== undefined ? `&available=${available}` : ""
      }&menu_id=${menu_id}`
    );
  },
  switchModeStopListProd(
    restaurant_id: string,
    product_id: string,
    is_available: boolean
  ) {
    const body = JSON.stringify({ available: !is_available });
    return instance.patch(
      `/v3/restaurant/${restaurant_id}/stoplist/${product_id}`,
      body
    );
  },
  updateStopLists(menu_id: string) {
    // return instance.post(`/v3/menus/${menu_id}/update-status-available`);
  },
  updateStops(restaurant_id: string) {
    return instance.patch(`/v2/stoplist`, { store_id: restaurant_id });
  },
  getProductStores(product_id: string, is_available: boolean) {
    return instance.get(
      `/v3/products/stores/${product_id}?is_available=${is_available}`
    );
  },
  enableProduct(product_id: string, data: any) {
    return instance.patch(`/v3/products/${product_id}/stoplist/enable`, data);
  },
  disableProduct(product_id: string, data: any) {
    return instance.patch(`/v3/products/${product_id}/stoplist/disable`, data);
  },
  disableProductWithTimePeriod(data: any) {
    return instance.post(`v2/scheduler/temp-cron`, data);
  },
};
